import { useCallback, useEffect } from 'react';
import { userSettingsStore } from '../../store/userSettingsStore';

const GameKeyboardKeys = { F11: 'F11' };

export const useFullScreen = () => {
  const { toggleFullscreen, setIsFullScreen, setAllowFullScreen } = userSettingsStore;
  const { document } = window;
  const { documentElement: htmlElement } = document;

  const handleFullScreenMode = useCallback(() => {
    const fullScreenElement =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;
    setIsFullScreen(!!fullScreenElement);
  }, [document, setIsFullScreen]);

  useEffect(() => {
    htmlElement.addEventListener('fullscreenchange', handleFullScreenMode); /* Standard syntax */
    htmlElement.addEventListener('mozfullscreenchange', handleFullScreenMode); /* Firefox */
    htmlElement.addEventListener(
      'webkitfullscreenchange',
      handleFullScreenMode
    ); /* Chrome, Safari and Opera */
    htmlElement.addEventListener('msfullscreenchange', handleFullScreenMode); /* IE / Edge */

    return () => {
      htmlElement.removeEventListener(
        'fullscreenchange',
        handleFullScreenMode
      ); /* Standard syntax */
      htmlElement.removeEventListener('mozfullscreenchange', handleFullScreenMode); /* Firefox */
      htmlElement.removeEventListener(
        'webkitfullscreenchange',
        handleFullScreenMode
      ); /* Chrome, Safari and Opera */
      htmlElement.removeEventListener('msfullscreenchange', handleFullScreenMode); /* IE / Edge */
    };
  }, [htmlElement, handleFullScreenMode]);

  useEffect(() => {
    document.addEventListener('keydown', (e) => {
      if (e.key === GameKeyboardKeys.F11) {
        e.preventDefault();
        toggleFullscreen();
      }
    });

    const isFullScreenAvailable =
      document.fullscreenEnabled ||
      document.webkitFullscreenEnabled ||
      document.mozFullScreenEnabled ||
      document.msFullscreenEnabled;
    const allowFullScreen =
      isFullScreenAvailable &&
      (!window.frameElement ||
        (window.frameElement && window.frameElement.hasAttribute('allowFullScreen')));
    setAllowFullScreen(allowFullScreen);
  }, [document, setAllowFullScreen, toggleFullscreen]);
};
